export default function(name: string) {
  for (const meta of document.getElementsByTagName("meta")) {
    if (meta.getAttribute("name") === name) {
      return meta.getAttribute("content");
    }
  }
  return null;
}
